export const viewTitle = "Настройки";
export const viewUniqKey = "settings";
